import { axiosInstance } from '~/common/utils/api.util';

import type { ApiResponse } from '~/common/types/api.type';
import type { WolAgentStatusDto } from '~/features/wol-agent/types/wol-agent.type';

/**
 * WOL Agent 실시간 상태 조회 (storeId 기반)
 * @endpoint GET /admin/wol-agents/{storeId}/status
 */
export function getWolAgentStatusApi(storeId: number) {
  return axiosInstance.get<ApiResponse<WolAgentStatusDto>>(`/admin/wol-agents/${storeId}/status`);
}
